// @todo: Migrate to @wandb/components. For more details see:
// https://www.notion.so/wandbai/Migrating-components-207e2f5c7ef380129201f72a5770a8db
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from '@wandb/weave/components/Button';
import {Tailwind} from '@wandb/weave/components/Tailwind';
import React from 'react';

import {useViewer} from '../../state/viewer/hooks';
import {Quickstart} from './Quickstart';

type ZeroModelsProps = {
  onCreateModel: () => void;
};

export const ZeroModels = ({onCreateModel}: ZeroModelsProps) => {
  const viewer = useViewer();
  const isLoggedIn = !!viewer;
  const onClickCreateModel = () => {
    onCreateModel?.();
  };
  return (
    <Tailwind
      style={{
        marginTop: '72px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        alignSelf: 'center',
      }}>
      <div className="flex w-[850px] flex-col items-center">
        <div className="text-2xl font-normal leading-[1.886rem]">
          Welcome to the model registry
        </div>
        <div className="mt-24 text-center text-lg font-normal leading-[1.575rem] text-moon-650">
          Publish the best model checkpoints from your experiments in W&B to a
          centralized team registry. View model lineage and action history,
          automate model CI/CD processes, and add permissions for model
          promotion.{' '}
          <div className="break-normal">
            Create a <span className="font-semibold">Registered model</span> to
            get started!
          </div>
        </div>
        {isLoggedIn && (
          <Button
            data-test="quickstart-create-collection-button"
            className="create-collection-2 mt-24"
            icon="add-new"
            size="large"
            onClick={onClickCreateModel}>
            Create collection
          </Button>
        )}
        <Quickstart onCreateModel={onClickCreateModel} />
      </div>
    </Tailwind>
  );
};
